
































































import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';
import AuthConnector from '@/connector/Auth.vue';

@Component({
  components: {
    AuthConnector,
  },
})
export default class LoginDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public username: string = '';

  public password: string = '';

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }
}
